import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ListOfActorsTags from '../ListOfActorsTags';
import ActorsModalBtn from '../ActorsModalBtn';

import { getDefaultGroups } from '../../selectors';

function AddActorsForNewActor({
  actorType,
  btnModalLabel,
  hideElements,
  onSaveCallBack,
}) {
  const defaultGroups = useSelector(getDefaultGroups);

  const defaultGroup = defaultGroups.filter((item) => item.uinfo.group_name === 'DEFAULT');
  const initLocalActors = actorType === 'user' || actorType === 'classic_user' ? defaultGroup : [];

  const [localActors, setLocalActors] = useState(initLocalActors);

  const onSaveCallBackAndSetLocalActors = (actors) => {
    const { selectedActors } = actors;
    setLocalActors(selectedActors);

    onSaveCallBack?.(actors);
  };

  const actorsUUIDs = localActors?.map((item) => item.uuid);

  return (
    <>
      <ActorsModalBtn
        initialActorsUUIDs={actorsUUIDs}
        actorType={actorType}
        btnModalLabel={btnModalLabel}
        hideElements={hideElements}
        doNotMakeRequest={['saveActors']}
        onSaveCallBack={onSaveCallBackAndSetLocalActors}
      />
      <ListOfActorsTags
        actors={localActors}
      />
    </>
  );
}

export default AddActorsForNewActor;

AddActorsForNewActor.propTypes = {
  actorType: PropTypes.string,
  btnModalLabel: PropTypes.string,
  hideElements: PropTypes.array,
  onSaveCallBack: PropTypes.func,
};
